import React from 'react';
import { Avatar } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { AvatarRow, AvatarWrapper, EditProfileButton } from './Styles';
import { getAvatarUrl } from './constants';
import type { AvatarSectionProps } from './types';

const AvatarSection: React.FC<AvatarSectionProps> = ({
  name,
  username,
  showEditButton,
  onEditClick,
}) => {
  const displayName = name || username || 'User';
  const avatarSrc = getAvatarUrl(name || '', username || '');

  return (
    <AvatarRow>
      <AvatarWrapper>
        <Avatar size={80} src={avatarSrc} alt={displayName}>
          {displayName.charAt(0).toUpperCase()}
        </Avatar>
      </AvatarWrapper>
      {showEditButton && (
        <EditProfileButton
          icon={<FontAwesomeIcon icon={faPenToSquare} />}
          onClick={onEditClick}
          aria-label="Edit Profile"
        >
          Edit Profile
        </EditProfileButton>
      )}
    </AvatarRow>
  );
};

export default React.memo(AvatarSection);
